import { useEffect, useState } from "react";
import MagnifyingGlassIcon from "@heroicons/react/24/solid/MagnifyingGlassIcon";
import { Card, InputAdornment, OutlinedInput, SvgIcon } from "@mui/material";

export const CustomersSearch = ({
  search,
  setSearch,
  placeholder = "Search Data",
}) => {
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  useEffect(() => {
    const delayTimer = setTimeout(() => {
      setSearch(debouncedSearch);
    }, 500);

    return () => {
      clearTimeout(delayTimer);
    };
  }, [debouncedSearch, setSearch]);

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setDebouncedSearch(value);
  };

  return (
    <Card sx={{ p: 2 }}>
      <OutlinedInput
        value={debouncedSearch}
        onChange={handleSearchChange}
        fullWidth
        placeholder={placeholder}
        startAdornment={
          <InputAdornment position="start">
            <SvgIcon color="action" fontSize="small">
              <MagnifyingGlassIcon />
            </SvgIcon>
          </InputAdornment>
        }
        // sx={{ maxWidth: 500 }}
      />
    </Card>
  );
};
